import React from 'react';
import ReactDOM from 'react-dom/client';
// import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './styles/vcreate.css';
import './styles/tapir.css';
import { AuthProvider } from './AuthContext';
import { NotificationProvider } from './NotificationContext';


const root = ReactDOM.createRoot(
  document.getElementById('outer-wrapper') as HTMLElement
);
root.render(
  <React.StrictMode>
    <NotificationProvider>
    <AuthProvider>
      
        <App />
      
    </AuthProvider>
    </NotificationProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
